module.exports = __webpack_public_path__ + "img/shogi_2021_pack_3_0006.ca2d6094.png";